import { memo } from "react";

import { Modal } from "../Modal";
import { MoveWaveActions } from "./MoveWaveActions";
import { MoveWaveContent } from "./MoveWaveContent";

export const MoveWave = memo(({ open, onClose, onContinue, onCancel }) => {
  const handleCancel = (e) => {
    onCancel && onCancel(e);
  };

  const handleContinue = (e) => {
    onContinue && onContinue(e);
  };

  return (
    <Modal
      open={open}
      title={"Move Wave"}
      onClose={onClose}
      maxWidth={"xs"}
      content={<MoveWaveContent />}
      actions={
        <MoveWaveActions onCancel={handleCancel} onContinue={handleContinue} />
      }
    />
  );
});

export default MoveWave;
